export { default } from "./UserDetailPanel.jsx"
